export default {
    path: '/houselist',
    meta: {
        title: '找房',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/`),
}


// WEBPACK FOOTER //
// ./src/views/HouseList/router.js